import { Button, Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import CloseIcon from "@mui/icons-material/Close"
import { SupplySummaryList } from "./SupplySummaryList"
import { ItemList, Main, PaddedArea, SummaryBar } from "./styled"
import { MobileLayout, displayName } from "./utils"
import { Header } from "@/components/Header/Header"
import { MobileAppHeader } from "@/components/Header/MobileAppHeader"
import { ReportFooter } from "@/components/Footer/ReportFooter"
import { RoomSupplyItem } from "@/hooks/useRoomSupply"
import { useTranslation } from "@/hooks/useTranslation"

export interface SelectedSupplyItem {
    item: RoomSupplyItem
    quantity: number
}

interface Props {
    selectedItems: SelectedSupplyItem[]
    submitting: boolean
    layout: MobileLayout
    onSubmit: () => void
    onBack: () => void
    onClose: () => void
}

export const ConfirmView = ({
    selectedItems,
    submitting,
    layout,
    onSubmit,
    onBack,
    onClose
}: Props) => {
    const { t } = useTranslation()

    return (
        <Main style={layout.rootProps.style}>
            <Header {...layout.headerProps}>
                <MobileAppHeader
                    title={
                        <Typography variant="h4">{t("内容の確認")}</Typography>
                    }
                    onPrev={onBack}
                    onNext={onClose}
                    nextIcon={<CloseIcon />}
                />
            </Header>

            <div {...layout.bodyProps}>
                <PaddedArea>
                    <Typography>
                        {t("以下の内容で不足品目を報告します。")}
                    </Typography>
                </PaddedArea>

                <ItemList>
                    <SummaryBar>{t("報告する内容")}</SummaryBar>
                    <SupplySummaryList
                        entries={selectedItems.map(({ item, quantity }) => ({
                            key: item.id,
                            name: displayName(item),
                            quantity
                        }))}
                    />
                </ItemList>
            </div>

            <ReportFooter {...layout.footerProps}>
                <Button
                    variant="filled"
                    color="primary"
                    fullWidth
                    disabled={submitting}
                    onClick={onSubmit}
                >
                    {t("この内容で報告する")}
                </Button>
                <Button
                    variant="outlined"
                    fullWidth
                    disabled={submitting}
                    onClick={onBack}
                    css={css`
                        margin-top: 8px;
                    `}
                >
                    {t("修正する")}
                </Button>
            </ReportFooter>
        </Main>
    )
}
